var _defs, _path, _circle, _circle2;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";
import Svg from 'ha/ui/next/SvgIcon';

const SvgHelpCenter = props => /*#__PURE__*/React.createElement(Svg, _extends({
  id: "help-center_svg__Layer_1",
  "data-name": "Layer 1",
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 32 32"
}, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".help-center_svg__cls-2{fill:none;stroke:#2d4658;stroke-miterlimit:10;stroke-width:1.5px}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M18.37 23.08l2.58 7.7-9.88-.15 2.45-7.26 4.85-.29zM13.63 8.94L11.01 1.1l9.96.17-2.49 7.37-4.85.3zm17.2 11.79l-7.09-2.26-.01-5 7.04-2.31.06 9.57zm-29.53.09l7.16-2.35-.57-5.06-6.76-2.16.17 9.57z",
  fill: "#00c5ba"
})), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
  className: "help-center_svg__cls-2",
  cx: 16,
  cy: 16,
  r: 15
})), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
  className: "help-center_svg__cls-2",
  cx: 16,
  cy: 16,
  r: 8
})));

export default SvgHelpCenter;